import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Cancellation } from '../../../../types/schema/cancellation.types';

interface GetAllCancellationsByPageHook {
  data: Cancellation[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllCancellationsByPage: Cancellation[];
    }>
  >;
}

interface GetAllCancellationsByPageMutationData {
  getAllCancellationsByPage: Cancellation[];
}

interface GetAllCancellationsByPageInputType {
  input: PaginationInput;
}

export function useGetAllCancellationsByPage(
  query: DocumentNode,
  input: PaginationInput
): GetAllCancellationsByPageHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllCancellationsByPageMutationData,
    GetAllCancellationsByPageInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllCancellationsByPage,
    loading,
    error,
    refetch,
  };
}
